const BannerMarquee = () => {
  return (
    <div className="w-full bg-red-600 py-2 flex justify-center overflow-hidden">
      <div className="max-w-7xl w-full flex items-center px-4 space-x-4 md:space-x-6">
        {/* Hotline bên trái - ẩn chữ "Hotline hỗ trợ:" trên mobile */}
        <div className="text-yellow-300 font-semibold whitespace-nowrap">
          <span className="hidden md:inline">Hotline hỗ trợ: </span>
          <a href="tel:0786529313" className="underline">078 652 9313</a>
        </div>

        {/* Chữ chạy marquee bên phải */}
        <div className="flex-1 whitespace-nowrap relative overflow-hidden">
          <div className="inline-block animate-marquee text-yellow-300 font-semibold text-sm sm:text-base">
            QUỐC DẠY LÁI XE - TRUNG TÂM DẠY LÁI XE UY TÍN CHẤT LƯỢNG - THÀNH PHỐ HỒ CHÍ MINH
          </div>
        </div>
      </div>
    </div>
  );
};

export default BannerMarquee;